import styles from './GrainField.module.css'

/**
 * The atmospheric grain layer.
 *
 * DESIGN.md move 05 — "grain tuned per surface, not global": `--grain-atmos` on
 * low-frequency ceremonial surfaces (sign-in, first-sync, empty states), a lower
 * `--grain-chrome` on everyday chrome, and **zero behind live prose**. This
 * component paints the atmos level only; it must never wrap the writing surface.
 *
 * Replaced the `Atmosphere` component, which drew a sun, dunes and drifting motes.
 * That was decoration layered on top of the UI — the exact thing the Mid Field
 * costume test rejects. Here atmosphere is a property of the surface, not an object
 * sitting in front of it.
 *
 * Renders behind content as an absolutely positioned, aria-hidden layer: the parent
 * must be `position: relative` and real content should sit above it.
 */
export default function GrainField() {
  return <div className={styles.grain} aria-hidden="true" />
}
